import { CompanyName } from '../../../common/assets/images'

const PaloAltoNetworks = () => {
  return (
    <div className='tw-mt-4 tw-pb-4' style={{ borderBottom: '1px solid rgb(0, 0, 0,0.1)' }}>
      <img style={{ width: '100%', height: '53.82px' }}
        className='tw-ml-4' alt={'companyName'}
        src={CompanyName} />
    </div>
  )
}

export default PaloAltoNetworks
